import styled from "styled-components";

export const Container = styled("div")(({ theme }) => ({
  width: "100%",
  height: "auto",
  padding: 12,
  gap: 20,
  backgroundColor: "#f8fafc",
  borderRadius: 24,

  display: "flex",

  [theme.down("md")]: {
    flexDirection: "column",
  },
}));

export const ContainerLeft = styled("div")(({ theme }) => ({
  flex: "2 1 0%",
  padding: 20,
}));

export const Header = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "start",
  gap: 8,
  marginBottom: 24,
}));

export const Title = styled("h1")(({ theme }) => ({
  fontSize: 28,
  fontWeight: 600,
  color: "#1a202c",
  margin: "0 0 12px 0",
  lineHeight: 1.2,
}));

export const Subtitle = styled("span")(({ theme }) => ({
  fontSize: 16,
  color: "#718096",
  margin: 0,
  display: "flex",
  alignItems: "center",
  gap: 8,
}));

export const FormContainer = styled("div")(({ theme }) => ({
  display: "flex",
  gap: 16,

  [theme.down("sm")]: {
    flexDirection: "column",
  },
}));
